import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Alert } from '@ibk/shared-ui';
import styles from './AnchoredAlert.module.css';
const CONTENT_TOP_OFFSET = 0;
const DEFAULT_TOP = 88;
const DEFAULT_RIGHT_OFFSET = 24;
export function AnchoredAlert({ message, appearance, duration, testId, testIdIdentifier, anchorRef, className, onClose, }) {
    const markerRef = useRef(null);
    const [position, setPosition] = useState({ top: DEFAULT_TOP, right: DEFAULT_RIGHT_OFFSET });
    useLayoutEffect(() => {
        const updatePosition = () => {
            const element = anchorRef?.current ?? markerRef.current;
            if (!element) {
                return;
            }
            const { top, right } = element.getBoundingClientRect();
            setPosition({
                top: top + CONTENT_TOP_OFFSET,
                right: Math.max(window.innerWidth - right, 0),
            });
        };
        updatePosition();
        window.addEventListener('resize', updatePosition);
        return () => window.removeEventListener('resize', updatePosition);
    }, [anchorRef]);
    return (_jsxs(_Fragment, { children: [_jsx("div", { ref: markerRef, className: styles.marker, "aria-hidden": true }), createPortal(_jsx("div", { className: [styles.anchor, className].filter(Boolean).join(' '), style: { top: `${position.top}px`, right: `${position.right}px` }, "data-testid": testId, children: _jsx(Alert, { alertType: 'inline', appearance: appearance, message: message, duration: duration, density: 'compact', alignItems: 'center', className: styles.alert, testIdIdentifier: testIdIdentifier, onClose: onClose }) }), document.body)] }));
}
